export default __webpack_public_path__ + "static/media/back-new.b9861f84.png";